import { useQuery } from '@tanstack/react-query'
import { listConversations } from './api'

/** Badge count for the Chats tab. Kept fresh by the conversations query. */
export function useUnreadTotal(): number {
  const { data } = useQuery({
    queryKey: ['conversations'],
    queryFn: () => listConversations(),
    staleTime: 15_000,
  })
  return (data ?? []).reduce((sum, c) => sum + c.unread_count, 0)
}
